// extracted by mini-css-extract-plugin
module.exports = {"name":"_c1eb137","isSuspended":"_5f56e53","status":"_afb090f","multipleNameWrapper":"_f828b43","right":"_abd8013"};